import Style from './VerificationCodeBrick.module.less';
import FJLocalStore from '../../store/FJLocalStore';
import FJNav from '../common/FJNav/FJNav';
import FJInput from '../common/FJInput/FJInput';
import FJButton from '../common/FJButton/FJButton';
import classNames from 'classnames';
import { useCallback, useEffect, useRef, useState } from 'react';
import FJErrTip from '../common/FJErrTip/FJErrTip';
import useLocalStore from '../../hooks/useLocalStore';
import FJUtil from '../../util/FJUtil';
import FJAction from '../../action/FJAction';
import { useDispatch, useSelector } from 'react-redux';
import FJLoading from '../common/FJLoading/FJLoading';
import loadingIcon from '../../assets/icon/loading_one.gif';

const VerificationCodeBrick = props => {
    const dispatch = useDispatch();
    useLocalStore();
    let { value, resendCode, confirmClick, stepChange, popupType, active } = props;
    const [code, setCode] = useState('');
    const [load, setLoad] = useState(false);
    const [errTip, setErrTip] = useState(null);
    let inputRef = useRef();

    const { time, countShow } = useSelector(store => {
        return {
            time: store.mainStore.forgetPasswordTime,
            countShow: store.mainStore.forgetPasswordTimeShow,
        };
    });

    let _navClick = () => {
        stepChange('confirmationEmail');
    };

    let _onChange = value => {
        _clean();
        setCode(value);
    };

    let formatValue = value => {
        return value.replace(/\D+/g, '');
    };

    let _clean = () => {
        inputRef.current.setInit();
        setErrTip(null);
    };
    // 格式验证
    let _formatCheck = useCallback(() => {
        let res = true;
        if (code.length === 0) {
            res = false;
            inputRef.current.setErrorMessage(FJLocalStore._('enter-verification-here'));
            return res;
        } else if (code.length > 0 && code.length < 6) {
            res = false;
            inputRef.current.setErrorMessage(FJLocalStore._('enter-verification-length'));
            return res;
        } else {
            inputRef.current.setInit();
        }
        return res;
    }, [code]);

    let _sendClick = useCallback(() => {
        let result = _formatCheck();
        if (!result) {
            return;
        }
        setLoad(true);
        const obj = {
            code,
            type: 2,
        };
        confirmClick(obj, option => {
            setLoad(false);
            if (option.networkFail) {
                setErrTip(option.errTip);
            } else if (option.result === true) {
                setErrTip(null);
            } else {
                setErrTip(option.errTip);
            }
        });
    }, [code, _formatCheck, confirmClick]);

    let _resendCode = () => {
        const _timeCount = FJUtil.countDown('forgetPassword', 60, value => {
            // 改变倒计时剩余时间，如果value 》= 0， 则调用reducers中的方法继续--
            if (Boolean(value)) {
                dispatch(FJAction.setForgetPasswordIntervalTime(value));
            } else {
                dispatch(FJAction.changeForgetPasswordTimeShow(false));
                dispatch(FJAction.setForgetPasswordIntervalTime(null));
            }
        });

        if (countShow === false) {
            // _timeCount();
            dispatch(FJAction.changeForgetPasswordTimeShow(true));
            resendCode(
                () => {
                    _timeCount();
                },
                () => {
                    dispatch(FJAction.changeForgetPasswordTimeShow(false));
                },
            );
        }
    };

    let _enterSendCode = useCallback(
        e => {
            if (e.keyCode === 13) {
                _sendClick();
            }
        },
        [_sendClick],
    );

    useEffect(() => {
        FJUtil.addEvent(window, 'keydown', _enterSendCode);
        return () => {
            FJUtil.removeEvent(window, 'keydown', _enterSendCode);
        };
    }, [_enterSendCode]);

    return (
        <div
            className={classNames(Style.code_box, { [Style.code_box_show]: active, [Style.code_box_popup]: popupType })}
        >
            <FJNav title={FJLocalStore._('forget-password')} onClick={_navClick} popupType={popupType} />
            <p
                className={Style.curTip}
                dangerouslySetInnerHTML={{ __html: FJLocalStore._('edit-code-to-continue').replace('xxx', value) }}
            />
            <FJInput
                value={code}
                onChange={_onChange}
                formatValue={formatValue}
                maxInputLength={6}
                label={FJLocalStore._('verification-code')}
                placeholder={FJLocalStore._('enter-verification-here')}
                type='text'
                className={Style.inputMargin}
                inputClassName={Style.input}
                ref={inputRef}
                popupType={popupType}
                // hasRightIcon
            />
            <FJErrTip errTip={errTip} />
            <FJButton
                text={FJLocalStore._('verify-email-code-continue')}
                small={popupType}
                className={Style.submit_btn}
                isLoading={load}
                onClick={_sendClick}
            />
            {countShow ? (
                <div className={Style.resend_time}>
                    {!Boolean(time) ? (
                        <FJLoading src={loadingIcon} loading={true} />
                    ) : (
                        FJLocalStore._('resend-code-after').replace('xxx', time)
                    )}
                </div>
            ) : (
                <p className={Style.resend_code} onClick={_resendCode}>
                    {FJLocalStore._('resend-code')}
                </p>
            )}
            {/*<input type='password' style={{height: '0',opacity: 0}}/>*/}
        </div>
    );
};
export default VerificationCodeBrick;
